<template>
	<v-dialog 
		v-model="dialog"
		:fullscreen="fullscreen"
		:max-width="maxWidth"
		persistent
	>
		<!-- Актіватор -->
		<template v-slot:activator="{ on: dialog, attrs }">
			<v-tooltip bottom>
				<template v-slot:activator="{ on: tooltip, attrs }">
					<slot name="activator" :attrs="attrs" :dialog="dialog" :tooltip="tooltip">
						<!-- <v-icon v-bind="attrs" v-on="{ ...tooltip, ...dialog }">{{ activatorIcon }}</v-icon> -->
						<v-btn icon v-bind="attrs" v-on="{ ...tooltip, ...dialog }">
							<v-icon>mdi-import</v-icon>
						</v-btn>
					</slot>
				</template>
				<span>{{ tooltip | capitalize }}</span>
			</v-tooltip>
		</template>

		<v-card>
			<v-toolbar flat dark color="primary" style="flex: 0 1 auto;">
				<v-avatar>
					<v-icon>{{ icon }}</v-icon>
				</v-avatar>
				<v-toolbar-title>{{ title }}</v-toolbar-title>
				
				<v-spacer></v-spacer>

				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn v-bind="attrs" v-on="on" icon @click="onLoadSettings" >
							<v-icon>mdi-folder</v-icon>
						</v-btn>
					</template>
					<span>Завантаження налаштувань</span>
				</v-tooltip>
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn v-bind="attrs" v-on="on" icon @click="onSaveSettings" >
							<v-icon>mdi-content-save</v-icon>
						</v-btn>
					</template>
					<span>Збереження налаштувань</span>
				</v-tooltip>
				
				<v-divider vertical></v-divider>

				<v-btn icon @click="fullscreen = !fullscreen">
					<v-icon v-if="fullscreen">mdi-arrow-collapse</v-icon>
					<v-icon v-else="fullscreen">mdi-arrow-expand</v-icon>
				</v-btn>
				<v-btn icon @click="dialog=false" >
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			
			<v-card-text>
				<v-form ref="form">
					<v-tabs v-model="tab" vertical>
						<v-tab v-for="(tab, index) in tabs" :key="index" class="d-flex justify-start">
							<v-icon left>{{ tab.icon }}</v-icon>
							{{ tab.title }}
						</v-tab>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<v-file-input 
										v-model="file.data.content"
										:accept="accept"
										@change="changeFile"
									></v-file-input>
									<!-- <v-file-input 
										v-model="file"
										:accept="accept"
										@change="changeFile"
									></v-file-input> -->
								</v-card-text>
							</v-card>
						</v-tab-item>
						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<!-- <v-select 
										v-model="item.sheetNames"
										:items="sheetNames"
										label="Аркуш"
										multiple
										hide-details="auto"
									></v-select> -->
									<v-row>
										<v-col cols="12">
											<v-select 
												v-model="item.sheet.name"
												:items="sheetNames"
												label="Аркуш"
												hide-details="auto"
											></v-select>
										</v-col>
										<v-col cols="12" md="6">
											<v-text-field
												v-model="item.sheet.row.start"
												label="Діапазон рядків з"
												hide-details="auto"
												type="number"
												min="1"
												:max="item.sheet.row.count"
											></v-text-field>
										</v-col>
										<v-col cols="12" md="6">
											<v-text-field
												v-model="item.sheet.row.end"
												label="Діапазон рядків по"
												hide-details="auto"
												type="number"
												min="1"
												:max="item.sheet.row.count"
											></v-text-field>
										</v-col>
									</v-row>
									
								</v-card-text>
							</v-card>
						</v-tab-item>
						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<v-row v-for="(header, row) in item.sheet.columns" :key="row" no-gutters>
										<v-col cols="12" md="6">
											<v-text-field class="mr-1"
												v-model="header.text"
												readonly
												hide-details="auto"
											></v-text-field>
										</v-col>
										<v-col cols="12" md="6">
											<v-select 
												v-model="header.column"
												:items="columns"
												hide-details="auto"
												clearable
												class="ml-1"
												return-object
											></v-select>
										</v-col>
									</v-row>

									<v-toolbar flat>
										<v-spacer></v-spacer>
										<v-btn small @click="clearColumns">
											<v-icon left>mdi-broom</v-icon>
											Очистити
										</v-btn>
									</v-toolbar>
								</v-card-text>
							</v-card>
						</v-tab-item>
						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<v-data-table
										:items="items"
										:headers="this.item.sheet.columns"
									></v-data-table>
									<!-- hide-default-footer
										:items-per-page="10" -->
								</v-card-text>
							</v-card>
						</v-tab-item>
					</v-tabs>
					<!-- <v-row  no-gutters>
						<v-col cols="12">
							<v-file-input 
								v-model="file"
								:accept="accept"
								@change="changeFile"
							></v-file-input>
						</v-col>
						<v-col cols="12" v-if="sheetNames.length">
							<v-select 
								v-model="item.sheetNames"
								:items="sheetNames"
								label="Аркуш"
								multiple
								hide-details="auto"
							></v-select>
						</v-col>

						<v-col cols="12" v-if="sheetNames.length">
							<v-row v-for="(header, row) in headers" :key="row" no-gutters>
								<v-col cols="12" md="6">
									<v-text-field class="mr-1"
										v-model="header.name"
										readonly
										hide-details="auto"
									></v-text-field>
								</v-col>
								<v-col cols="12" md="6">
									<v-select 
										v-model="header.column"
										:items="columns"
										hide-details="auto"
										clearable
										class="ml-1"
									></v-select>
								</v-col>
							</v-row>
						</v-col>
					</v-row> -->
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-btn depressed v-if="visibleBtnLeft" @click="tab--">
					<v-icon left>mdi-arrow-left</v-icon>
				</v-btn>
				<v-spacer></v-spacer>
				
				<v-spacer></v-spacer>
				<v-btn depressed v-if="visibleBtnRight" @click="tab++">
					<v-icon left>mdi-arrow-right</v-icon>
				</v-btn>
				<v-btn text @click.native="onCancel" v-if="visibleActionFinish">{{ $vuetify.lang.t('$vuetify.cancel') }}</v-btn>
				<v-btn color="success" dark @click.native="onOK" :disabled="loading" v-if="visibleActionFinish">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
			</v-card-actions>
		</v-card>
		
		<v-file-input class="d-none"
			v-model="file.settings.content"
			ref="FileSettings"
			:accept="file.settings.accept"
			@change="changeFileSettings"
		></v-file-input>

		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
	</v-dialog>
</template>

<script>
import * as XLSX from 'xlsx'; //https://www.npmjs.com/package/xlsx

export default {
	name: 'Import',
	components: {},
	data: () => ({
		dialog: false,
		fullscreen: false,
		loading: false,
		
		//file: null,

		file: {
			data: {
				content: null
			},
			settings: {
				name: 'Імпорт.Налаштування.json',
				accept: 'application/json',
				content: null
			}
		},

		workbook: null,

		item: {
			sheet: {
				name: null,
				row: {
					start: 1,
					end: 1,
					count: 0,
				},
				columns: []
			}
		},

		tab: 0,
		tabs: [
			{ code: 'file', title: 'Файл', icon: 'mdi-paperclip' },
			{ code: 'sheet', title: 'Аркуші', icon: 'mdi-tab' },
			{ code: 'column', title: 'Поля', icon: 'mdi-view-column' },
			{ code: 'preview', title: 'Попередній перегляд', icon: 'mdi-table' },
		],
	}),
	props: {
		title:  		{ type: String, default: 'Імпорт'},
		tooltip:  		{ type: String, default: 'Імпорт'},
		icon:  			{ type: String, default: 'mdi-import'},
		maxWidth: 		{ type: [String,Number], default: 800 },
		//selected: 		{ type: Object, default: () => {} },
		disabled:   	{ type: Boolean, default: false }, //Ознака неактивного елементу

		accept:  		{ type: String },
		headers:		{ type: Array, default: () => [] },

		//activatorType:  { type: String, default: 'icon'}, // Тип активатора вікна: button | icon | menu-item | list-item
		//activatorIcon:  { type: String, default: 'mdi-trash-can'},
	},

	watch: {
		dialog(val) {
			if(val) {
				this.item.sheet.columns = this.headers
			}
		}
	},
	
	computed: {
		sheetNames() {
			return this.workbook?.SheetNames ? this.workbook.SheetNames : []
		},

		columns() {
			let result = []
			for (let i = 1; i <= 52; i++) {
				result.push({
					text: this.convertToExcelColumn(i),
					value: i
				})
			}

			return result
		},

		visibleBtnLeft() {
			return this.tab
		},
		visibleBtnRight() {
			return this.tab+1 < this.tabs.length
		},
		visibleActionFinish() {
			return this.tab+1 == this.tabs.length
		},

		dataArray() {
			let result = []

			if(this.workbook && this.item.sheet.name) {
				const worksheet 	= this.workbook.Sheets[this.item.sheet.name];
				const data_array 	= XLSX.utils.sheet_to_json(worksheet, { header: 1 });
				result = data_array;
			}

			this.item.sheet.row.end 	= result.length
			this.item.sheet.row.count 	= result.length
			
			return result
		},
	
		items() {
			let result = []

			//console.log(this.$options.name, 'items', 'dataArray', this.dataArray)
			//console.log(this.$options.name, 'items', 'headers', this.item.sheet.columns)

			const row_start = this.item.sheet.row?.start ? this.item.sheet.row.start : 1;
			const row_end 	= this.item.sheet.row?.end > 0 ? this.item.sheet.row.end : this.dataArray.length;

			//console.log(this.$options.name, 'items', 'row_end', row_end)

			this.dataArray.forEach((data, row_index) => {
				if(row_index+1 >= row_start && row_index+1 <= row_end) {
					const item = {};
					this.item.sheet.columns.forEach((header) => {
						const type = header?.type ? header.type : 'string' 
						const column = header.column
						if(column) {
							let value = data[column.value - 1]
							
							switch(type) {
								case 'int': 	value = parseInt(value); break;
								case 'float':	value = parseFloat(value); break;
							}

							if(header?.getValue) {
								value = header.getValue(value)
							}

							this.createNestedProperty(item, header.value, value);
						}
					})

					result.push(item)
				}
			})

			//console.log(this.$options.name, 'items', 'result', result)

			return result
		},
	},

	methods: {
		changeFile(files) {
			if(Array.isArray(files)) {
				files.forEach((file) => this.processFile(file))
			} else {
				this.processFile(files)
			}
		},

		/**
		 * Обробка файлу
		 * @param file 
		 */
		processFile(file) {
			if (file) {
				const fileName = file.name;
				const lastDotIndex = fileName.lastIndexOf('.');
				const fileExtension = lastDotIndex !== -1 ? fileName.substring(lastDotIndex + 1) : null
				
				switch(fileExtension) {
					case 'xlsx': this.processFileExcel(file); break;
				}
			}
		},

		/**
		 * Обробка файлу Excel
		 * @param file 
		 */
		processFileExcel(file) {
			if (file) {
				const reader = new FileReader();

				reader.onload = (e) => {
					//console.log(this.$options.name, 'processFileExcel', 'XLSX', XLSX)

					//let result = {}

					const bstr = e.target.result;
					//const workbook = XLSX.read(bstr, { type: 'binary' });

					this.workbook = XLSX.read(bstr, { type: 'binary' });

					if(this.workbook.SheetNames.length) {
						//this.item.sheetNames.push(workbook.SheetNames[0])
						this.item.sheet.name = this.workbook.SheetNames[0]
					}
				}

				reader.readAsArrayBuffer(this.file.data.content);
			}
		},

		/**
		 * Обробка файлу Excel
		 * @param file 
		 */
		processFileExcelSheet(workbook, sheetName) {
			const worksheet 	= workbook.Sheets[sheetName];
			const data_array 	= XLSX.utils.sheet_to_json(worksheet, { header: 1 });

			//const items = [];
			data_array.forEach((data) => {

				const item = {};
				this.item.sheet.columns.forEach((header) => {
					const type = header?.type ? header.type : 'string' 
					const column = header.column
					if(column) {
						let value = data[column.value - 1]
						
						switch(type) {
							case 'int': 	value = parseInt(value); break;
							case 'float':	value = parseFloat(value); break;
						}

						this.createNestedProperty(item, header.value, value);
					}
					
				})

				this.items.push(item)
			})
		},

		clearColumns() {
			this.item.sheet.columns.forEach(item => item.column = null);
		},
		
		onCancel () {
			this.dialog = false
		},

		onOK () {
			this.dialog = false
			this.$emit('ok', this.items)
		},

		/**
		 * Функція для перетворення цифрового значення в літерні назви стовпців Excel (наприклад, 1 → A, 2 → B, 27 → AA)
		 * @param num 
		 */
		convertToExcelColumn(num) {
			let column = '';
			let tempNum = num;

			while (tempNum > 0) {
				let remainder = tempNum % 26;
				
				// Якщо залишок 0, це Z.
				// Зменшуємо tempNum, щоб уникнути нескінченного циклу і перейти до попереднього "розряду"
				if (remainder === 0) {
					column = 'Z' + column;
					tempNum = (tempNum / 26) - 1;
				} else {
					// Використовуємо ASCII-код, щоб отримати літеру (65 - це 'A')
					column = String.fromCharCode(64 + remainder) + column;
					tempNum = Math.floor(tempNum / 26);
				}
			}

			return column;
		},

		/**
		 * Функція, що перетворює літерне позначення стовпця Excel на його числовий еквівалент
		 * @param column 
		 */
		convertFromExcelColumn(column) {
			let result = 0;
			let multiplier = 1;

			// Проходимо по рядку справа наліво
			for (let i = column.length - 1; i >= 0; i--) {
				// Визначаємо числове значення літери (A=1, B=2, ...)
				const charValue = column.charCodeAt(i) - 64;
				
				// Додаємо значення, помножене на відповідну степінь 26
				result += charValue * multiplier;
				
				// Збільшуємо множник для наступної ітерації (26^0, 26^1, 26^2...)
				multiplier *= 26;
			}
			
			return result;
		},

		/**
		 * Функція створення глибоко вкладених об'єктів на основі рядка
		 * @param obj 
		 * @param path 
		 * @param value 
		 */
		createNestedProperty(obj, path, value) {
			//console.log(this.$options.name, 'createNestedProperty', 'path', path)

			// Розділяємо шлях на окремі ключі
			const keys = path.split('.');
			
			// Починаємо з кореневого об'єкта
			let current = obj;
			
			// Проходимо по всіх ключах, крім останнього
			for (let i = 0; i < keys.length - 1; i++) {
				const key = keys[i];
				
				// Якщо поточного ключа не існує або він не є об'єктом, створюємо його
				if (!current[key] || typeof current[key] !== 'object') {
					current[key] = {};
				}
				
				// Переходимо на наступний рівень вкладеності
				current = current[key];
			}
			
			// Присвоюємо значення останньому ключу
			const lastKey = keys[keys.length - 1];
			current[lastKey] = value;
		},

		/**
		 * Завантаження файлу Налаштувань
		 * Load JSON
		 */
		onLoadSettings() {
			this.file.settings.content = null
			this.$refs.FileSettings.$refs.input.click()
		},

		changeFileSettings (e) {
			//JSON.parse

			const file = this.file.settings.content;
			if (file) {
				const reader = new FileReader();
				reader.onload = (e) => {
					try {
						this.item = JSON.parse(e.target.result);
						/* let jsonData = JSON.parse(e.target.result);
						if(jsonData?.headers) {
							this.headers.splice(0, this.headers.length);
							jsonData.headers.forEach((element) => this.headers.push(element))
						} */
					} catch (error) {
						console.error("Error parsing JSON:", error);
						//this.jsonData = null; // Clear data on error
						alert("Invalid JSON file.");
					}
				};

				reader.readAsText(file);
			} else {
				//this.jsonData = null; // Clear data if no file selected
			}
		},

		/**
		 * Збереження файлу Налаштувань
		 * Save JSON
		 */
		onSaveSettings() {

			const filename = this.file.settings.name;
			/* const text = JSON.stringify({
				headers: this.headers
			}); */
			const text = JSON.stringify(this.item);

			const blob = new Blob([text], { type: 'application/json' });
			const url = URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.href = url;
			a.download = filename;
			document.body.appendChild(a);
			a.click();

			document.body.removeChild(a);
			URL.revokeObjectURL(url);
		}
	},
}
</script>